import { initializeApp } from "firebase/app";
import type { AppCheck } from "firebase/app-check";
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
} from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { config } from "./config";

export const app = initializeApp(config.firebase);
export const functions = getFunctions(app, config.functionsRegion);
export const db = getFirestore(app);

if (config.useEmulator) {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

if (isLocalhost && config.appCheckDebugToken) {
  (self as { FIREBASE_APPCHECK_DEBUG_TOKEN?: string })
    .FIREBASE_APPCHECK_DEBUG_TOKEN = config.appCheckDebugToken;
}

const appCheckEnabled = !!config.recaptchaSiteKey && !config.useEmulator;

export const appCheck: AppCheck | null = appCheckEnabled
  ? initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(config.recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
  : null;
